import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getUsuarioCursoListSuccess(usuariocurso) {
  return {type: types.LOAD_USUARIOCURSO_LIST_SUCCESS, usuariocurso};
}



export function getUsuarioCursoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().UsuarioCursoApi.getUsuarioCursoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(usuariocurso => {                  
                  dispatch(getUsuarioCursoListSuccess(usuariocurso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getUsuarioCursoSuccess(catalogo) {
  return {type: types.LOAD_USUARIOCURSO_SUCCESS, catalogo};
}

export function getUsuarioCurso(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().UsuarioCursoApi.getUsuarioCurso(id, token).then(usuariocurso => {   
        dispatch(getUsuarioCursoSuccess(usuariocurso));
        return usuariocurso;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getUsuarioCursoPrevio(token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().UsuarioCursoApi.getUsuarioCursoPrevio(token).then(usuariocurso => {   
        dispatch(getUsuarioCursoSuccess(usuariocurso));
        return usuariocurso;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}





export function saveSuccess(usuariocurso) {
  return {type: types.SAVE_USUARIOCURSO_SUCCESS, usuariocurso};
}


export function save(usuariocurso, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().UsuarioCursoApi.save(usuariocurso, token).then(usuariocursoGuardado => {   
    dispatch(saveSuccess(usuariocursoGuardado));
    return usuariocursoGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveImagen(file, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().UsuarioCursoApi.saveImagen(file, token).then(imagenGuardado => {
    dispatch(saveSuccess(imagenGuardado));
    return imagenGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function getUsuarioCursoComboSuccess(datos) {
  return {type: types.GET_USUARIOCURSOS_COMBO_SUCCESS, datos};
}

export function getUsuarioCursoCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().UsuarioCursoApi.getUsuarioCursoCombo(token).then(datos => {   
        
      dispatch(getUsuarioCursoComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(usuariocurso) {
  return {type: types.BORRAR_USUARIOCURSO_SUCCESS, usuariocurso};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().UsuarioCursoApi.borrar(id, token ).then(usuariocurso => {
               
                  dispatch(borrarSuccess(usuariocurso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(usuariocurso) {
  return {type: types.ACTIVAR_USUARIOCURSO_SUCCESS, usuariocurso};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().UsuarioCursoApi.activar(id, token).then(usuariocurso => {
               
                  dispatch(activarSuccess(usuariocurso));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_USUARIOCURSO, filtro};
}



